import React, { createContext, useMemo } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { login, logout } from "./auth/keycloak";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  const value = useMemo(() => {
    const isAuthenticated = initialized && !!keycloak.authenticated;
    const user = keycloak.tokenParsed || null;

    return {
      isAuthenticated,
      isLoading: !initialized,
      user,
      token: keycloak.token || null,
      login,
      logout,
    };
  }, [initialized, keycloak]);

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};
